import * as React from "react";

import { ButtonGroup } from "@blueprintjs/core";
import ContactTwoToneIcon from "@material-ui/icons/EmailTwoTone";
import MyLocationTwoTone from "@material-ui/icons/MyLocationTwoTone";
import QuestionAnswerTwoToneIcon from "@material-ui/icons/QuestionAnswerTwoTone";
import SettingsBackupRestoreTwoToneIcon from "@material-ui/icons/SettingsBackupRestoreTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import { shopConfig } from "~/helpers/shopConfig";
import Button from "./Button";

const ICONS = {
  chat: QuestionAnswerTwoToneIcon,
  contact: ContactTwoToneIcon,
  return: SettingsBackupRestoreTwoToneIcon,
  tracking: MyLocationTwoTone
};

interface ITopic {
  key: "tracking" | "return" | "chat" | "contact";
  title: string;
  description?: string;
}

class ButtonsList extends React.Component<
  WithTranslation & RouteComponentProps
> {
  public render() {
    const { t } = this.props;

    const topics: ITopic[] = t("actionButtons", {
      returnObjects: true,
      ...shopConfig
    });

    if (!topics) {
      return null;
    }

    return (
      <React.Fragment>
        <ButtonGroup fill={true} large={true}>
          {topics.slice(0, 2).map(topic => {
            return (
              <Button
                key={topic.key}
                icon={ICONS[topic.key]}
                title={topic.title}
                description={topic.description}
                onClickHandler={this.handleTopicClick(topic.key)}
              />
            );
          })}
        </ButtonGroup>

        <ButtonGroup fill={true} large={true}>
          {topics.slice(2, topics.length - 1).map(topic => {
            return (
              <Button
                key={topic.key}
                icon={ICONS[topic.key]}
                title={topic.title}
                description={topic.description}
                onClickHandler={this.handleTopicClick(topic.key)}
              />
            );
          })}
        </ButtonGroup>

        <ButtonGroup fill={true} large={true}>
          {topics.slice(topics.length - 1, topics.length).map(topic => {
            return (
              <Button
                key={topic.key}
                icon={ICONS[topic.key]}
                title={topic.title}
                description={topic.description}
                onClickHandler={this.handleTopicClick(topic.key)}
              />
            );
          })}
        </ButtonGroup>
      </React.Fragment>
    );
  }

  private handleTopicClick = (topic: string) => (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    const { history } = this.props;

    switch (topic) {
      case "tracking":
        history.push({ pathname: "/track-trace" });
        break;
      case "return":
        history.push({ pathname: "/rma/request" });
        break;
      case "contact":
        history.push({ pathname: "/contact" });
        break;
      case "chat":
        (window as any).location.pathname = "/pages/service";
        break;
    }
  };
}

export default compose(
  withTranslation("interactiveDashboard"),
  withRouter
)(ButtonsList);



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/ButtonsList.tsx